import React from 'react';
import { RelativePeriod, RelativePeriodLabel2 } from '@components/comparison-period-selector/Types';
import { BaseTimePeriod } from '@services/FiltersTypes';
import WithRadio from '@components/design/WithRadio';

export type ComparisonPeriodsProps = {
  comparisonOptions: RelativePeriod[];
  selectedComparison: RelativePeriod | BaseTimePeriod;
  selectComparisonCallback: (comp: RelativePeriod) => void;
  isComparisonOptionsDisabled: boolean;
};

const ComparisonPeriods: React.FC<ComparisonPeriodsProps> = ({
  comparisonOptions,
  selectedComparison,
  selectComparisonCallback,
  isComparisonOptionsDisabled,
}) => {
  const options = comparisonOptions.map((option) => ({
    label: RelativePeriodLabel2[option],
    value: option,
  }));
  return (
    <div>
      <WithRadio
        title="Comparison Period"
        options={options}
        value={selectedComparison}
        isDisabled={isComparisonOptionsDisabled}
        onChange={(value) => {
          selectComparisonCallback(value);
        }}
        orientation="vertical"
      />
    </div>
  );
};

export default ComparisonPeriods;
